import React, {Fragment, useMemo} from 'react';
import {translate} from 'react-i18next';
import {Icon} from 'antd';
import {
    mappingTypeDefault
} from "../../../../data-manager/file-mapping/wizard/utils";
import {MARGIN_XL, PADDING_SM, PADDING_XS} from "../../../../../styles/constants";

const mappingIsSelected = (mapping, selectedMapping, columnNameKey, dsdColumnNameKey) => {
    return mapping && selectedMapping &&
        mapping[columnNameKey] === selectedMapping[columnNameKey] &&
        mapping[dsdColumnNameKey] === selectedMapping[dsdColumnNameKey];
}

const divContainerStyle = {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #e8e8e8",
    height: `calc(100% - ${MARGIN_XL}px)`
}

const divComponentsStyle = {
    overflow: "auto",
    padding: PADDING_SM
}

const divComponentStyle = {
    paddingTop: PADDING_XS,
    paddingBottom: PADDING_XS,
    paddingLeft: PADDING_SM,
    paddingRight: PADDING_SM,
    minWidth: 120,
}

const MappingSetMappingComponentList = ({
                                            t,
                                            mappings,
                                            selectedMapping,
                                            onSelect,
                                            columnNameKey,
                                            dsdColumnNameKey,
                                        }) => {

    const defaultMappings = useMemo(() => (mappings || []).filter(m => m.mappingType === mappingTypeDefault), [mappings]);
    const nonDefaultMappings = useMemo(() => (mappings || []).filter(m => m.mappingType !== mappingTypeDefault), [mappings]);

    return (
        <Fragment>
            <div style={divContainerStyle}>
                {
                    defaultMappings.length > 0 && (
                        <div style={{...divComponentsStyle, flex: 1}}>
                            {
                                defaultMappings.map((mapping, index) =>
                                    <div
                                        key={index}
                                        onClick={() => onSelect ? onSelect(mapping) : null}
                                        title={onSelect
                                            ? `${t("commons.actions.select.title")} ${Array.isArray(mapping[columnNameKey]) ? mapping[columnNameKey].join(", ") : mapping[columnNameKey]} - ${mapping[dsdColumnNameKey]}`
                                            : null
                                        }
                                        style={{
                                            ...divComponentStyle,
                                            cursor: onSelect ? "pointer" : "cursor",
                                            background: mappingIsSelected(mapping, selectedMapping, columnNameKey, dsdColumnNameKey)
                                                ? "#ffafa3"
                                                : (index % 2)
                                                    ? "#f5f5f5"
                                                    : "#ffffff",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "calc(50% - 24px)",
                                                verticalAlign: "middle",
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            {Array.isArray(mapping[columnNameKey]) ? mapping[columnNameKey].join(", ") : mapping[columnNameKey]}
                                        </div>
                                        <Icon
                                            type="link"
                                            style={{
                                                width: 32,
                                                marginLeft: 8,
                                                marginRight: 8,
                                                verticalAlign: "middle",
                                                display: "inline-block"
                                            }}
                                        />
                                        <div
                                            style={{
                                                width: "calc(50% - 24px)",
                                                verticalAlign: "middle",
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            {mapping[dsdColumnNameKey]}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
                {
                    nonDefaultMappings.length > 0 && (
                        <div style={{...divComponentsStyle}}>
                            <div
                                style={{fontWeight: "bold"}}
                            >
                                {t('scenes.dataManager.fileMapping.wizard.componentList.componentsWithValue.title')}
                            </div>
                            {
                                nonDefaultMappings.map((mapping, index) => {
                                        const mappingExpression = mapping.constantValue;
                                        return (
                                            <div
                                                key={`vAss_${index}`}
                                                onClick={() => onSelect ? onSelect(mapping) : null}
                                                style={{
                                                    ...divComponentStyle,
                                                    cursor: onSelect ? "pointer" : "cursor",
                                                    background: mappingIsSelected(mapping, selectedMapping, columnNameKey, dsdColumnNameKey)
                                                        ? "#ffafa3"
                                                        : (index % 2)
                                                            ? "#f5f5f5"
                                                            : "#ffffff"
                                                }}
                                            >
                                                    <span
                                                        style={{
                                                            width: "calc(100% - 32px)",
                                                            verticalAlign: "middle",
                                                            display: "inline-block",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                        }}
                                                        title={mappingExpression}
                                                    >
                                                      <b>{mapping[dsdColumnNameKey]}</b>={mappingExpression}
                                                    </span>
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>
                    )
                }
            </div>
        </Fragment>
    );
}


export default translate()(MappingSetMappingComponentList);
